export default class Helper {
  public static circularReplacer() {
    const seen = new WeakSet();
    return (key, value) => {
      if (typeof value === "object" && value !== null) {
        if (seen.has(value)) {
          return;
        }
        seen.add(value);
      }
      return value;
    };
  }

  public static getInitials(name: string) {
    if(!name) {
      return '!';
    }
    return name.split(' ').filter((str) => {
      return str.length > 0;
    }).map((str) => {
      return str.substr(0, 1).toUpperCase();
    }).join('');
  }

  public static randomColorByName(name: string) {
    let colors = [
      'bg-green-600', 'bg-blue-600', 'bg-purple-600',
      'bg-orange-600', 'bg-yellow-600', 'bg-teal-600',
      'bg-red-600', 'bg-indigo-600', 'bg-pink-600'
    ];

    if(name == null) {
      return colors[0];
    }

    let sum = 0;
    for(let i = 0; i < name.length; i++) {
      sum += name.charCodeAt(i);
    }

    const offset = sum % colors.length;

    return colors[offset];
  }
}
